import React, { createContext, useContext, useState, useEffect } from 'react';

// Define theme color options
export const THEMES = {
  GOLD: {
    id: 'gold',
    name: 'Gold',
    secondary: '#C9A43D', // Gold
    secondaryLight: '#D4B04A',
    secondaryDark: '#B89834',
  },
  GREEN: {
    id: 'green',
    name: 'Emerald',
    secondary: '#10B981', // Emerald Green
    secondaryLight: '#34D399',
    secondaryDark: '#059669',
  },
  BLUE: {
    id: 'blue',
    name: 'Sapphire',
    secondary: '#3B82F6', // Blue
    secondaryLight: '#60A5FA',
    secondaryDark: '#2563EB',
  },
  RED: {
    id: 'red',
    name: 'Ruby',
    secondary: '#EF4444', // Red
    secondaryLight: '#F87171',
    secondaryDark: '#DC2626',
  },
  PURPLE: {
    id: 'purple',
    name: 'Amethyst',
    secondary: '#8B5CF6', // Purple
    secondaryLight: '#A78BFA',
    secondaryDark: '#7C3AED',
  },
};

const ThemeContext = createContext();

export const useTheme = () => {
  return useContext(ThemeContext);
};

export const ThemeProvider = ({ children }) => {
  // Dark mode state - always forced to true (dark mode)
  const [darkMode] = useState(true);

  // Color theme state - fixed to GOLD
  const [colorTheme] = useState(THEMES.GOLD);

  // Force dark mode on initial load
  useEffect(() => {
    // Always add dark mode class
    document.documentElement.classList.add('dark');
    // Set darkMode in localStorage
    localStorage.setItem('darkMode', 'true');
  }, []);

  useEffect(() => {
    // Update CSS variables for the theme colors
    document.documentElement.style.setProperty('--color-secondary', colorTheme.secondary);
    document.documentElement.style.setProperty('--color-secondary-light', colorTheme.secondaryLight);
    document.documentElement.style.setProperty('--color-secondary-dark', colorTheme.secondaryDark);
    document.documentElement.style.setProperty('--color-primary', '#000000');
  }, [colorTheme]);

  const value = {
    darkMode,
    colorTheme,
    availableThemes: THEMES
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider; 